//@flow
import React, { Component } from 'react';
import type { Node } from 'react';
import injectSheet from 'react-jss';
import modalCss from '../styles/modal';
import { Button } from '@hiver/hiver-ui-kit';

/**
* This file is responsible for displaying a reusable modal
* @author Jitin and Sumit
*/
type State = {
    openModal: boolean
}
type Props = {
    classes: Object,
    modalContent: Node,
    modalWarning: Node,
    footerContent: Node,
    shown: boolean,
    thick: boolean,
    options: Object,
    leftBtnText: string,
    leftBtnType: string,
    leftBtnHandler: Function,
    rightBtnText: string,
    rightBtnType: string,
    rightBtnHandler: Function
}
class Modal extends Component<Props, State> {

    constructor(props) {
        super(props);
        this.state = {
            openModal: false
        };
    }

    componentWillReceiveProps(nextProps) {
        const { shown } = nextProps;
        this.setModalState(shown);
    }
    

    setModalState(state) {
        this.setState({
            openModal: state
        });
    }

    componentWillMount() {
        const { shown } = this.props;
        this.setModalState(shown);
    }

    render() {
        const { openModal } = this.state;
        if(!openModal) {
            return null;
        }
        const { 
            classes, 
            modalContent,
            modalWarning,
            leftBtnText, 
            leftBtnType, 
            leftBtnHandler,
            rightBtnText, 
            rightBtnHandler, 
            rightBtnType,
            footerContent,
            thick,
            options
        } = this.props;
        let containerClass = (rightBtnText || leftBtnText || thick) ? classes.modalCont:  `${classes.modalCont} thin`
        if (options && options.thinner)
            containerClass = `${containerClass} thinner`
        return (
            <div className={classes.modal}>
                <div className={containerClass}>
                    <div className={classes.modalContent}>{modalContent}</div>
                    { (leftBtnText || rightBtnText) && <div className={classes.modalAction}>
                        { leftBtnText && <Button
                                onClick={leftBtnHandler}
                                color="tertiary"
                                size="medium"
                                variant="outlined"
                            >
                                {leftBtnText}
                            </Button>
                        }
                        {
                           rightBtnText && <Button
                                onClick={rightBtnHandler}
                                color="error"
                                size="medium"
                                variant="contained"
                            >
                                {rightBtnText}
                            </Button>
                        }
                        </div>
                    }
                    {
                        modalWarning && <div className={classes.warningInfo}>
                            {modalWarning}
                        </div>
                    }
                </div>
                { footerContent && 
                    <div className={classes.footer}>
                        {footerContent}
                    </div>
                }
            </div>
        );
    }
}

export default injectSheet(modalCss)(Modal);    